import { NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { Language } from '@global/enums/language.enum';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';
import { ROOT_REDUCERS } from 'app/reducers';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { translateLoaderProvider } from './providers/translate-loader.provider';

@NgModule({
  declarations: [],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: Language.English,
      loader: translateLoaderProvider,
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),

    StoreModule.forRoot(ROOT_REDUCERS, {
      runtimeChecks: {
        strictStateSerializability: true,
        strictActionSerializability: true,
        strictActionWithinNgZone: true,
      },
    }),
    StoreRouterConnectingModule.forRoot(),
    environment.production ? [] : StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot(),
  ],
})
export class CoreModule {}
